// src/pages/RecuperarPassword.jsx
import React, { useState } from "react";
import {
  Container,
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  CircularProgress,
} from "@mui/material";
import "../styles/recuperarPassword.css";

const RecuperarPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccessMsg("");
    setErrorMsg("");

    try {
      const response = await fetch("http://localhost:8000/api/recuperar-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (response.ok) {
        setSuccessMsg(data.message || "Correo de recuperación enviado correctamente.");
        setEmail("");
      } else {
        setErrorMsg(data.detail || "No se pudo enviar el correo de recuperación.");
      }
    } catch (error) {
      setErrorMsg("Error de conexión con el servidor.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container maxWidth="sm" className="recuperar-container">
      <Paper elevation={3} className="recuperar-paper">
        <Typography variant="h5" className="recuperar-titulo">
          Recuperar Contraseña
        </Typography>
        <Typography variant="body2" className="recuperar-subtitulo">
          Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña.
        </Typography>

        <Box component="form" onSubmit={handleSubmit} className="recuperar-form">
          <TextField
            fullWidth
            label="Correo Electrónico"
            type="email"
            variant="outlined"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="recuperar-input"
          />

          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            className="recuperar-boton"
            disabled={loading}
          >
            {loading ? <CircularProgress size={24} /> : "Enviar enlace de recuperación"}
          </Button>
        </Box>

        {successMsg && <Alert severity="success">{successMsg}</Alert>}
        {errorMsg && <Alert severity="error">{errorMsg}</Alert>}
      </Paper>
    </Container>
  );
};

export default RecuperarPassword;
